'use strict';

var d3 = require('d3');
var ChartForecastProfileView = function ChartForecastProfileView(AbstractChart, chartCurves, chartXAxis, chartYAxis, chartVerticalLine, chartHoverOver, chartConstants, chartZoom, chartRectClip, $location, userPreferencesService) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters, interpolate) {
    AbstractChart.call(this, container);
    this.tooltipClassName = 'forecast-profile-chart';
    var curves = chartCurves('dtd', 'demand', 'curveData');
    var verticalLine = chartVerticalLine('dtd', 'caption');
    var xAxisMode = chartConstants.AXIS.MODE.LEFT;
    var xAxis = chartXAxis(formatters.xAxisTickFormatter).label('Days to Departure');
    if (userPreferencesService.getUserDateTimeSettings('defaultRTPView') === chartConstants.DIRECTION.RTL) {
      xAxisMode = chartConstants.AXIS.MODE.RIGHT;
    }
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, xAxisMode).withoutHorizontalLines().label('Demand');
    var hoverOver = chartHoverOver('curveData', 'dtd', 'demand', formatters.tooltipFormatter, interpolate, this.tooltipClassName);
    this.render = function (data, verticalLineData) {
      var clipPathId = 'chart-forecast-profile-clip';
      d3.select('#' + clipPathId).remove();
      var zoom = chartZoom();
      var verticalLineWithData = verticalLine.withData(verticalLineData);
      this.initChart(data, undefined, chartParams);
      this.scales = chartScales(this.params, this.data, userPreferencesService.getUserDateTimeSettings('defaultRTPView'));
      curves.clipPath($location.path() + '#' + clipPathId);
      var rectClip = chartRectClip();
      this.svg.call(rectClip.id(clipPathId).x(0).y(-this.params.padding.bottom).width(this.container.width()).height(this.container.height()));
      this.callForDataGroup([curves, verticalLineWithData, hoverOver, yAxisLeft, xAxis], this.scales);
      var redrawElementsWrapper = function redrawElementsWrapper() {
        this.svg.select('.group-axes').remove();
        this.callForDataGroup.call(this, [curves, verticalLineWithData, hoverOver, xAxis, yAxisLeft]);
      };
      this.svg.call(zoom.params(this.params).scales(this.scales).toRedraw([redrawElementsWrapper.bind(this)]));
    };
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ChartForecastProfileView.$inject = ['AbstractChart', 'ChartElementsCurves', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsVerticalLine', 'ChartElementsHoverOver', 'ChartElementsConstants', 'ChartElementsZoom', 'ChartElementsRectClip', '$location', 'UserPreferencesService'];
module.exports = ChartForecastProfileView;